import { OfficePwa } from './office-pwa';
var app = new OfficePwa();
// hard redirect to office.com root
if (!app.canRender()) {
    window.location.href = '/';
}
app.initializeGlobalFunctions();
app.initVars();
app.initApp();
